

import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'
const Menu = () => {
    const { currentUser } = useAuth();
    console.log("cu", currentUser);

    // const features = [
    //     { name: 'Feedstock', icon: 'feedstockISCC', to: 'feed' },
    //     { name: 'Processing', icon: 'processingISCC', to: 'Iscc-Processing' },
    //     {
    //         name: 'GHG Transport',
    //         icon: 'streetcar',
    //         to: 'transport',
    //     },
    //     {
    //         name: 'Self Declaration',
    //         icon: 'selfdeclarationISCC',
    //         to: 'self-declaration',
    //     },
    //     {
    //         name: 'Input Inventory',
    //         icon: 'SDISCC',
    //         to: 'sd',
    //     },
    //     {
    //         name: 'Output Inventory',
    //         icon: 'SDISCC',
    //         to: 'sd2',
    //     },
    //     {
    //         name: 'PoS',
    //         icon: 'POSISCC',
    //         to: 'posIscc',
    //     },
    // ];



    const features = [
        { name: 'Feedstock', icon: 'feedstockISCC', to: 'feed' },
        { name: 'Processing', icon: 'processingISCC', to: 'Iscc-Processing' },
        {
            name: 'GHG Transport',
            icon: 'streetcar',
            to: 'transport',
        },
        {
            name: 'Self Declaration',
            icon: 'selfdeclarationISCC',
            to: 'self-declaration',
        },
        {
            name: 'Input Inventory',
            icon: 'SDISCC',
            to: 'sd',
        },
        {
            name: 'Output Inventory',
            icon: 'SDISCC',
            to: 'sd2',
        },
        {
            name: 'PoS',
            icon: 'POSISCC',
            to: 'posIscc',
        },
    ].filter(feature => {
        if ((currentUser as any)?.userType === "CLIENT") {
            return !['feed', 'Iscc-Processing', 'transport'].includes(feature.to);
        }
        return true;
    });


    return (
        <KTCard addCard={false}>
            <div className='row g-xl-4'>
                {features.map((eachFeature) => (
                    <div key={eachFeature.to} className='col col-lg-2'>
                        <Link className={clsx('menu-link without-sub')} to={eachFeature.to}>
                            <Card4
                                icon={`/media/svg/files/${eachFeature.icon}.png`}
                                title={eachFeature.name}
                                description=''
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </KTCard>
    );
};

const ISSEUMenu = () => <Menu />

export { ISSEUMenu }
